/** @jsx $mol_jsx */
/** @jsxFrag $mol_jsx_frag */
namespace $.$$ {
	$mol_jsx_view
	export class $shm_hitalama_map_widget_view_autoview extends $.$shm_hitalama_map_widget_view_autoview {
		
		@ $mol_mem
		code_view() {
			const widget = this.code_widget()
			if( !widget ) return undefined
			// if( !widget || widget.removed() ) return undefined

			return ( this.Map_page().Widget( widget.link() ).Sub() ) as
				| $shm_hitalama_map_widget_float_code
				| undefined
		}

		autoview_content() {
			const res = this.result()
			if( res === null ) return [ this.Run() ]
			if( res?._format == 'table' ) return [ this.Table() ]
			return [ this.Dom_wrapper() ]
		}

		@ $mol_mem
		Dom_wrapper() {
			const res = this.result()

			if( res instanceof $mol_view ) {
				return res
			}
			if( res?.getAttribute?.('data-crus-ref') ) {
				return res
			}
			
			if( res instanceof Node ) {
				const div = document.createElement('div')
				div.style.userSelect = 'text'
				div.style.display = 'contents'
				const shadow = div.attachShadow({ mode: "open" })
				shadow?.appendChild( res )
				return div
			}

			return this.Dump()
		}

		@ $mol_mem
		result() {
			const code = this.code_widget()
			if( code.removed() && code.enabled() ) {
				return this.code_view()?.Bench().run()
			}

			return $mol_error_fence( ()=> {
				return this.code_view()?.Bench().Process().state() as any
			}, ( error )=> {
				this.$.$mol_wait_timeout(2000)
				throw error
			} ) ?? null
		}

		run_click() {
			this.code_view()?.run_click()
		}

		@ $mol_mem
		table_rows() {
			return this.result()?.table?.rows ?? []
		}

		@ $mol_mem
		table_col_ids() {
			const head: string[] = this.result()?.table?.head ?? []
			return head.map( ( _, index )=> index )
		}

		@ $mol_mem_key
		table_col_head_content( index: number ) {
			const head: string[] = this.result()?.table?.head ?? []
			return [ head[ index ] ?? '' ]
		}
		
	}
}
